
import "./Statistics.css"
const StatisticsTechStack = ()=>{
    return(
        <div className="stat-cards">
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>CI/CD Tools</h1>
                    <img src='https://i.postimg.cc/D0pg4820/image.png' alt='fav' />
                </div>
                <p>Jenkins, GitLab</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Cloud Providers</h1>
                    <img src='https://cdn-icons-png.flaticon.com/512/4215/4215831.png' alt='fav' />
                </div>
                <p>AWS, Azure, GCP</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Infrastructure as Code</h1>
                    <img src='https://em86uxaq6bn.exactdn.com/wp-content/uploads/Infrastructure-as-Code.png?strip=all&lossy=1&quality=92&webp=92&sharp=1&ssl=1' alt='fav' />
                </div>
                <p>Terraform</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Configuration Management</h1>
                    <img src='https://cdn.iconscout.com/icon/premium/png-256-thumb/engine-crash-7692031-6281559.png?f=webp' alt='fav' />
                </div>
                <p>Ansible</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Continuous Deployment</h1>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUph41h6yxauq_n3mN3iUali-Kot5aelWU85jpfaoqU4r0xwyrlqijMk_0tCS085l41k4&usqp=CAU' alt='fav' />
                </div>
                <p>ArgoCD</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Container Orchestration </h1>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1vUwDC_od3cPPUccJDANSCqcHFoeBxaQoQpTgbFwbJ_lONtvWIMLCJJNqhkfZKrDJ7EQ&usqp=CAU' alt='fav' />
                </div>
                <p>Kubernetes</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Monitoring</h1>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpsTnMW0TSPkZWXq4icZqTiHnLBrJolNGtHSTWZpM_gxv62LgKELtd1TNQj2c0brzW0OI&usqp=CAU' alt='fav' />
                </div>
                <p>Prometheus</p>
            </div>
            <div className="stat-card-tech">
                <div className="stat-header tech">
                    <h1>Security</h1>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaNGHL0pEuqxTfZVistka3woeC-RcAITgIjoYg5qnLSUMyyyHTtVQKpeORb8lKjSyZXXg&usqp=CAU' alt='fav' />
                </div>
                <p>Integrated DevSecOps tools</p>
            </div>
            
        </div>
    )
}

export default StatisticsTechStack;